// Webpack Imports
import * as bootstrap from 'bootstrap';

( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );

	( function($){
		/*
		* Load More Function(s)
		* Check if page-image-load-more class is present on the page
		* */
		if( $('body').find('.page-image-load-more').length !== 0 ){
			if( $('body').find('.load-more-button').length !== 0 ){
				$('body').on('click', '.btnLoadMoreImage', function(e){
					e.preventDefault();
					$(".page-image-load-more > .page-image-list__item:hidden").slice(0, 6).slideDown();
					if( $(".page-image-load-more > .page-image-list__item:hidden" ).length == 0 ) {
						$( this ).text("No Content").addClass("noContent");
					}
				});
			}
		}





		/*
		*
		* Button Load more for the post type
		*
		* */

		if( $('body').find('.page-post-type').length !== 0 ){

			let ajaxURL     = frontend_ajax_object.ajaxurl,
				nonceAjax   = frontend_ajax_object.nonce;

			$('body').on('click', '.load-more-button .btn', function(e){
				let post_type       = $(this).attr('attr-post-type'),
					paged           = $(this).attr('attr-paged'),
					max_num_page    = $(this).attr('attr-max-num-page'),
					post_per_page   = $(this).attr('attr-post-per-page'),
					$this           = $(this),
					data            = {
						nonce   :   nonceAjax,
						data    :   {
							post_type       :   post_type,
							paged           :   paged,
							max_num_page    :   max_num_page,
							post_per_page   :   post_per_page
						},
						action  :   "actionCSTLoadMore"
					};

				if( data ){

					$.post( ajaxURL, data, function( data ){
						let post        = $.parseJSON( data ),
							html        = "";

						if( post ){

							$.each( post, function( key, value ){
								html += `<article id = 'post-${value.post_id}' class ='col-lg-4 col-md-6 mb-3 post-${value.post_id} ${post_type} type-${post_type} status-publish has-post-thumbnail hentry'>`;
									html += '<div class="post-card mb-4">';
										html += '<header class="post-card-body">';
											if( post_type == "webinarsvideos" ){
												html += '<div class = "video-holder position-relative">';
													html += '<div class = "post-card__thumbnail post-thumbnail border-radius-10">';
														html += `<img src = "${value.post_image_url}" alt = "${value.post_title}" class = "attachment-full size-full wp-post-image">`;
														html += `<button class = "video-play btn-modal-open" data-post-id = "${value.post_id}" data-bs-toggle="modal" data-bs-target="#videoModal-${value.post_id}" data-url="#videoModal-${value.post_id}"><i class="fa fa-play" aria-hidden="true"></i></button>`;
													html += '</div>';
												html += '</div>';
											}

											if( post_type == "modules" ){
												html += `<a href = "${value.post_url}" title = "${value.post_title}" rel = "bookmark"><div class = "post-card__thumbnail post-thumbnail border-radius-10"><img src = "${value.post_image_url}" alt = "${value.post_title}" class = "attachment-full size-full wp-post-image"></div></a>`;
												html += `<h4 class="post-card__title"><a href = "${value.post_url}" title="${value.post_title}" rel = "bookmark">${value.post_title}</a></h4>`;
											}
										html += '</header>';
										html += '<div class="post-card-body">';
											html += '<div class="post-card__text entry-content">';
												html += '<div class="date-holder my-3">';
													html += '<img src="http://localhost/gwpv2/wp-content/themes/gfva/assets/images/events/calendar.svg" alt=""> ';
													html += `<a href = "${value.post_url}" title="${value.post_date}" rel = "bookmark">${value.post_date}</a>`;
												html += '</div>';
												html += '<div class="content-excerpt mb-4">';
													html += `<p>${value.post_excerpt}</p>`;
												html += '</div>';
												html += '<div class="btn-wave">';
													html += `<a href = "${value.post_url}" title = "${value.post_title}" class="btn-link">Read More</a>`;
													html += '<div class="line-wave"></div>';
												html += '</div>';
											html += '</div>';
										html += '</div>';
									html += '</div>';
								html += `</article>`;

								if( post_type == "webinarsvideos" ){
									html += `<div class = "modal fade video-modal" id = "videoModal-${value.post_id}" data-bs-backdrop = "static" data-bs-keyboard = "false" tabindex="-1" aria-labelledby="#videoModal-${value.post_id}" aria-hidden="true">`;
										html += '<div class="modal-dialog modal-dialog-centered modal-xl">';
											html += '<div class = "modal-content">';
												html += '<button title="Close (Esc)" type="button" class="mfp-close btn-modal-closed" data-bs-toggle="modal">×</button>';
												html += '<div class="ratio ratio-16x9">';
													html += `<iframe  width="560" height="315" src = "${value.post_video_url}" title = "${value.post_title} video player Youtube" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="" style="max-width: 100%; max-height: 56px;"></iframe>`;
												html += '</div>';
											html += '</div>';
										html += '</div>';
									html += `</div>`;
								}
							});

							$('.page-post-type .container > .row').append( html ).hide().fadeIn();

							if( parseInt(paged) === parseInt(max_num_page) ){
								$this.closest('.load-more-button').hide();
							}else{
								$this.attr('attr-paged', ( parseInt(paged) + 1) );
							}

						}
					} );
				}
			});
		}

		/*
		* Nav Search Popup
		* */

		$('body').on('click', '.nav-item-search > a', function(e){
			$(this).next('.dropdown-content').toggle('slow');
		});


		// VIDEO MODAL

		$('.btn-modal-closed').on('click', function() { 
			var iframe      = $(this).closest('.modal-content').find('iframe');
			var iframeSrc   = iframe.attr('src');

			if( iframe.length !== 0 ){
				iframe.attr( 'src', iframeSrc );
			}
		});

		/*
		* Ordering GFVA Resources Page
		* */
		$('body').on('change', '.request-list .checkbox-rect2 input[type=checkbox]', function(e) {
			const $checkbox         = $(this);
			const $card             = $checkbox.closest('.card');
			const $quantityInput    = $checkbox.closest('.checkbox-rect2').next('.quantity').find('input[type="button"]');

			$card.addClass('card-disabled');
			$checkbox.attr('disabled', 'disabled');
			$quantityInput.attr('disabled', 'disabled');

			const request_id    = $checkbox.attr('id');
			const request_name  = $checkbox.val();
			const request_list  = $("<li></li>");

			request_list.append(
				$("<h4 class='d-inline'></h4>").text(request_name),
				$("<a href='javascript:void(0)' title='Remove Option' class='btnRemoveRequest'><i class='fa fa-times' aria-hidden='true'></i></a>").attr('attr-request-name', request_id)
			);

			$('.request-cart-list').show();
			$('.request-cart-list .request-cart-list__items ul').append(request_list);

			setTimeout(request_cart_list, 2000);
		});

		$(document).on('click', '.btnRemoveRequest', function(e){
			e.preventDefault();
			let request_name    = $(this).attr('attr-request-name');
			const requestList   = $('.request-list .checkbox-rect2 #' + request_name );

			requestList.removeAttr('disabled', 'disabled');
			requestList.closest('.checkbox-rect2').next('.quantity').find('input[type="button"]').removeAttr('disabled');
			requestList.closest('.card').removeClass('card-disabled');
			requestList.prop( "checked", false );

			$(this).closest('li').remove();
			request_cart_list();
		});

		function request_cart_list() {
			const selectedCheckboxes    = $('.request-list .checkbox-rect2 input[type=checkbox]:checked');
			const countCheckRequest     = selectedCheckboxes.length;
			let request_list_check      = "",
				requestCounter          = 0,
				seperator               = ",";

			selectedCheckboxes.each( function (i, checkbox ){
				requestCounter++;

				const quantityInput = $(checkbox).closest('.checkbox-rect2').next('.quantity').find('.qty');
				const qty           = parseInt(quantityInput.val()) || 1;
				const stocks        = parseInt( quantityInput.attr('attr-limit-stocks') );

				if( parseInt( countCheckRequest ) === parseInt( requestCounter ) )
					seperator = " ";

				request_list_check += $(checkbox).attr('attr-order') + "-" + $(checkbox).val() + "-" + qty + "/" + stocks + seperator;
			});

			$('.form-group.request-cart-list-field textarea').text(request_list_check);
		}

		$('.request-list .quantity').on('click', '.plus', function(e) {
			let $input  = $(this).prev('input.qty');
			let val     = parseInt($input.val());

			if( parseInt( $input.attr('attr-limit-stocks') ) !== val && parseInt( $input.attr('attr-limit-stocks') ) >= val ){
				$input.val( val+1 ).change();
			}
		});

		$('.request-list .quantity').on('click', '.minus', function(e) {
			let $input = $(this).next('input.qty');
			var val = parseInt($input.val());
			if (val > 0) {
				$input.val( val-1 ).change();
			}
		});

		$(".mobile-nav .menu-item-has-children").each(function() {
			var sub_child = $(this).find('.dropdown-menu').children().length;
			if (sub_child > 0) {
				$(this).find('.caret').addClass('fa fa-caret-down');
			}
		});

		$('.mobile-nav li .caret').click(function (e) {
			e.preventDefault();
			$(this).toggleClass('active');
			$(this).toggleClass('fa-caret-down');
			$(this).toggleClass('fa-caret-up');
			$(this).parent('a').parent('li').children('.dropdown-menu, .dropdown-content').slideToggle(100);
		});

		$('.js-filter').on('click',function(){
			$('body').toggleClass('open-filter').removeClass('open-search');
		});


        var forEach = function(array, callback, scope) {
          for (var i = 0; i < array.length; i++) {
            callback.call(scope, i, array[i]); // passes back stuff we need
          }
        };

        var randomIntFromInterval = function(min,max) {
          return Math.floor(Math.random()*(max-min+1)+min);
        }

        var $mapPins = document.querySelectorAll('#map-shape g');


        forEach(document.querySelectorAll('.list-rank .rank-number'), function(index, value) {
         
           value.addEventListener('mouseenter', function(e) {  

             var location2 = e.target.getAttribute('data-location');
          
	           
             
             forEach($mapPins, function(index, value) {
               if (value.getAttribute('data-location') !== location2) {
               	$("#map-shape g:not([data-location="+location2+"])").css('opacity',0);
                 document.querySelector('#map-shape g[data-location='+location2+']').style.opacity=1;

               }
             });
           }, false);

           value.addEventListener('click', function(e) {  

             var location2 = e.target.getAttribute('data-location');

             // Hide other map pins
             forEach($mapPins, function(index, value) {
               if (value.getAttribute('data-location') !== location2) {
                 document.querySelector('#map-shape g[data-location='+location2+']').style.opacity=1;
               }
             });
           }, false);

           value.addEventListener('mouseleave', function(e) {
            // Reverse all hidden map pins

            var elem_pin = document.querySelectorAll("#map-shape g");
            for (var i = 0; i < elem_pin.length; i++) {
              elem_pin[i].style.opacity = 1;
            }

            forEach($mapPins, function(index, value) {
               value.groupTimeline.reverse();
            });
            
          }, false);

        });


        		// Top to scroll
						var btn = $('#topbutton');

							$(window).scroll(function() {
							  if ($(window).scrollTop() > 300) {
							    btn.addClass('show');
							  } else {
							    btn.removeClass('show');
							  }
							});

							btn.on('click', function(e) {
							  e.preventDefault();
							  $('html, body').animate({scrollTop:0}, '300');
							});


        
	} (jQuery) );

} )();